export default __webpack_public_path__ + "static/media/727.7a60bb13.gif";